import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import * as axios from 'axios';
import * as Bowser from 'bowser';
import arcConfig from '@arcgis/core/config';
import dva from 'dva';
import './index.scss';
import { getAppConfig } from './services/config';
import { getUser } from './lib/user';
import { initializeFirebase } from './lib/firebase';
import { setWindowConfig, addToConfig } from './lib/config';
import * as serviceWorker from './serviceWorker';
import App from './components/App';
import appModel from './models/app';
import collectionsModel from './models/collections';
import dataManagerModel from './models/dataManager';
import featuresModel from './models/features';
import importSidebarModel from './models/importSidebar';
import layersModel from './models/layers';
import mapModel from './models/map';
import modalsModel from './models/modals';
import shareModel from './models/share';
import terrainModel from './models/terrain';
import historicalImageryModel from './models/historicalImagery';
import toastModel from './models/toast';
import userModel from './models/user';
import userPreferencesModel from './models/userPreferences';
import MNTNPixelScript from './scripts/MNTN';
import { amplitudeInit, brazeInit } from './lib/analytics/analyticsUtils';

arcConfig.assetsPath = process.env.NODE_ENV == 'development' ? './assets' : process.env.PUBLIC_URL + '/assets';

if (process.env.NODE_ENV === 'production') {
  MNTNPixelScript()
}

let appConfig = {};
let uapiConfig = {};
let apiVal = null;

const browserParser = Bowser.getParser(window.navigator.userAgent);
const isMobile = browserParser.getPlatformType(true) == 'mobile';
/* TODO: Check to see if condition below is needed */
// const isIE = browserParser.getBrowserName() == 'Internet Explorer';

if (isMobile) {
  window.location.replace('https://join.gohunt.com/try/download-maps/');
}

axios.get(process.env.PUBLIC_URL + '/config.env.json')
  .then((res) => {
    const envConfig = res.data;

    setWindowConfig({
      'REACT_APP_GA_KEY': envConfig.REACT_APP_GA_KEY,
      'REACT_APP_AMPLITUDE_API_KEY': envConfig.REACT_APP_AMPLITUDE_API_KEY,
      'REACT_APP_BRAZE_SDK_KEY': envConfig.REACT_APP_BRAZE_SDK_KEY,
      'REACT_APP_GO2HUNT_SHOP_URL': envConfig.REACT_APP_GO2HUNT_SHOP_URL,
      'REACT_APP_USER_API_URL': envConfig.REACT_APP_USER_API_URL,
      'REACT_APP_USER_DATA_API_URL': envConfig.REACT_APP_USER_DATA_API_URL,
    });

    apiVal = envConfig.REACT_APP_API_SECRET;
    appConfig = envConfig;

    return res.data;
  })
  .then((configObj) => {
    initializeFirebase(configObj);
    return getAppConfig(apiVal);
  })
  .then((appConfigRes) => {
    // set axios default
    const config = appConfigRes.data;
    uapiConfig = config;

    addToConfig({
      BASEMAP_LAYERS: config.BASEMAP_LAYERS,
      BASEMAPS_SERVICE: config.URL_BASEMAP_SERVICES,
      FEEDBACK_URL: config.FEEDBACK_URL,
      GH_ASSETS_CLOUDFRONT_URL: config.GH_ASSETS_CLOUDFRONT_URL,
      LAYERS_MAJOR: config.LAYERS_MAJOR,
      LAYERS_MINOR: config.LAYERS_MINOR,
      MAPS_ENVIRONMENT: config.MAPS_ENVIRONMENT,
      REVERSE_GEOCODE_SERVICE: config.URL_AND_PATH_ARC_GIS_REVERSE_GEOCODE_SERVICE,
      SERVER_ARC_GIS: config.SERVER_ARC_GIS,
      WAYBACK_IMAGERY_CONFIG_URL: config.WAYBACK_IMAGERY_CONFIG_URL,
      WAYBACK_REQUEST_TOKEN: config.WAYBACK_REQUEST_TOKEN,
      WAYBACK_TILE_SERVICE_URL: config.WAYBACK_TILE_SERVICE_URL,
    });

    if (process.env.REACT_APP_API_GATEWAY != null) {
      axios.defaults.baseURL = process.env.REACT_APP_API_GATEWAY;
    } else {
      axios.defaults.baseURL = config.SERVER_GH_MAPS;
    }
  })
  .catch((err) => {
    console.log('APP INITIALIZATION ERROR', err);
  })
  .finally(async () => {
    ga('create', window.__env.REACT_APP_GA_KEY, 'auto'); // eslint-disable-line
    ga('send', 'pageview'); // eslint-disable-line
    amplitudeInit(); // Analytics: Amplitude Tracking Initialisation
    brazeInit(); // Analytics: Braze Tracking Initialisation
    const app = dva();
    let user;

    try {
      user = await getUser()      
    } catch (err) {
      console.error('Error ----->>>> ', err);
      window.location.replace('http://join.gohunt.com/try/maps');
    }

    app.router(() => <App appConfig={{ ...appConfig, ...uapiConfig }} basemaps={uapiConfig.BASEMAPS.web} liveLayers={uapiConfig.LIVE_LAYERS} />);

    app.model(appModel);
    app.model(collectionsModel);
    app.model(dataManagerModel);
    app.model(featuresModel);
    app.model(historicalImageryModel);
    app.model(importSidebarModel);
    app.model(layersModel);
    app.model(mapModel);
    app.model(modalsModel);
    app.model(shareModel);
    app.model(terrainModel);
    app.model(toastModel);
    app.model(userModel);
    app.model(userPreferencesModel);

    app.start('#root');
  });


// app._store.dispatch({type: 'app/gotoSidebar', payload: 'IMPORT'});

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
